import React from "react";
import { useTranslation } from "react-i18next";

import Carousel from "../../shared/components/Carousel";

import { teachersData } from "./utils/teachersData";

import classes from "./index.module.css";

const Teachers = () => {
  const { t } = useTranslation();

  return (
    <div id="teachers" className={classes["wrapper"]}>
      <p className={classes["title"]}>{t("Our teachers")}</p>
      <Carousel data={teachersData} />
    </div>
  );
};

export default Teachers;
